
<template>
  <div class="hi-upload-file">
    <template v-if="arrFileData && arrFileData.length > 0">
      <!-- 1、图片展示 -->
      <div
        v-for="(file,index) in arrFileData"
        :key="index"
        v-width="widthData"
        class="img-list"
        @click="showImage(index)"
      >
        <div class="img-item">
          <div
            v-if="file.type === 'video'"
            class="video-div"
          >
            <i class="el-icon-video-play" />
          </div>
          <el-image
            v-else
            :src="file.url"
            :fit="'contain'"
            @error="loadError()"
          >
            <div
              slot="error"
              class="image-error"
            >
              <i class="el-icon-picture-outline" />
            </div>
          </el-image>
        </div>
        <span
          v-if="isShowName"
          class="file-name-class"
          :title="file.name"
        >{{ file.name }}</span>
        <span
          v-if="isShowFilmingDate && file.filmingDatetime"
          class="file-date-class"
          :title="file.filmingDatetime"
        >拍摄日期:{{ file.filmingDatetime }}</span>
        <span
          v-if="isShowWatermarkDate && file.watermarkDatetime"
          class="file-date-class"
          :title="file.watermarkDatetime"
        >水印日期:{{ file.watermarkDatetime }}</span>
        <span
          v-if="isValidateWarning && file.validateWarning"
          class="file-date-class text-red"
          :title="file.validateWarning"
        >{{ file.validateWarning }}</span>
      </div>

      <!-- 2、图片预览 -->
      <el-dialog
        :visible.sync="dialogVisible"
        :before-close="modalClose"
        class="preview-dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
      >
        <!-- 技术点：一定使用v-if="dialogVisible" 不能使用v-show,否则图片展示时（假设点击的是第3张），前两张会快速的滑过-->
        <div
          v-if="dialogVisible"
          class="block"
        >
          <span
            class="el-image-viewer__btn el-image-viewer__close"
            @click="modalClose"
          ><i class="el-icon-error" /></span>
          <el-carousel
            trigger="click"
            class="imgbox"
            :autoplay="false"
            arrow="always"
            indicator-position="outside"
          >
            <el-carousel-item
              v-for="(item,index) in imagesPreview"
              :key="index"
            >
              <img
                v-if="item.showUrl"
                :src="item.showUrl"
                style="max-height: 100%; max-width: 100%;"
              >
              <img
                v-else
                :src="item.url"
                style="max-height: 100%; max-width: 100%;"
              >
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-dialog>
      <!-- 视频播放 -->
      <el-dialog
        v-if="dialogVideoVisible"
        title="播放视频"
        :visible.sync="dialogVideoVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        destroy-on-close
        append-to-body
        class="abow_dialog"
      >
        <div style="height:100%;text-align: center;">
          <video
            :src="videoUrl"
            controls="controls"
            class="avatar video-avatar"
            style="height:100%;"
          >
            您的浏览器不支持视频播放
          </video>
        </div>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="dialogVideoVisible=false">
            关闭
          </el-button>
        </div>
      </el-dialog>
    </template>
    <template v-else>
      <span>无</span>
    </template>
  </div>
</template>

<script>
export default {
  directives: { // 自定义宽度指令
    'width': {
      bind(el, binding) {
        el.style.width = binding.value
      }
    }
  },
  props: {
    arrFileData: {
      type: Array,
      default: function () {
        return []
      }
    },
    // 图片宽度，默认82px，也可以传百分比，如30%
    widthData: {
      type: String,
      default: '82px'
    },
    isShowName: {
      type: Boolean,
      default: false
    },
    isShowFilmingDate: {
      type: Boolean,
      default: false
    },
    isShowWatermarkDate: {
      type: Boolean,
      default: false
    },
    isValidateWarning: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false, // 预览窗口是否展示，默认不展示
      downLoadFlag: true, // 下载图标展示与否，默认展示
      imagesPreview: [],// 预览时根据点击的index重组的数据
      dialogVideoVisible: false,
      videoUrl: '',
      baseUrl: '',
      nasUrl: ''
    }
  },
  methods: {
    /** 图片加载失败调用 */
    loadError() {
      this.downLoadFlag = false// 下载图标不显示
    },
    /** 图片预览 */
    showImage(index) {
      if (!this.downLoadFlag) {
        return false
      }
      this.baseUrl = process.env.VUE_APP_BASE_API
      this.nasUrl = process.env.VUE_APP_NAS_API
      this.imagesPreview = []
      let imgArr = this.arrFileData
      let before = imgArr.slice(0, index)
      let after = imgArr.slice(index)
      let fileArr = after.concat(before)
      let file = fileArr[0]
      let timeString = '0'
      if(file.url.indexOf('?t=') > -1){
        timeString = file.url.split('?t=')[1]
      }
      let nasYearMonth = Number(new Date().getFullYear() - 1) + '12'
      if(file.attachmentUrl){
        let attachmentUrl = file.attachmentUrl
        if (attachmentUrl.indexOf('.mp4') !== -1 || attachmentUrl.indexOf('.avi') !== -1 || attachmentUrl.indexOf('.wmv') !== -1 || attachmentUrl.indexOf('.mov') !== -1 || attachmentUrl.indexOf('.MP4') !== -1 || attachmentUrl.indexOf('.AVI') !== -1 || attachmentUrl.indexOf('.WMV') !== -1 || attachmentUrl.indexOf('.MOV') !== -1) {
          if(attachmentUrl.startsWith('/upload/')){
            attachmentUrl = attachmentUrl.substring(1)
          }
          let yearMonth = attachmentUrl.split('/')[2].substring(0,6)
          if(Number(nasYearMonth) > Number(yearMonth)){
            this.videoUrl = this.nasUrl + attachmentUrl + '?t=' + timeString
          } else {
            this.videoUrl = this.baseUrl + attachmentUrl + '?t=' + timeString
          }
          this.dialogVideoVisible = true
        } else {
          fileArr.forEach(fileItem =>{
            let attachmentUrl = fileItem.attachmentUrl
            if(attachmentUrl.startsWith('/upload/')){
              attachmentUrl = attachmentUrl.substring(1)
            }
            let yearMonth = attachmentUrl.split('/')[2].substring(0,6)
            if(Number(nasYearMonth) > Number(yearMonth)){
              fileItem.showUrl = this.nasUrl + attachmentUrl + '?t=' + timeString
            } else {
              fileItem.showUrl = this.baseUrl + attachmentUrl + '?t=' + timeString
            }
          })
          this.dialogVisible = true
          this.imagesPreview = fileArr
        }
      } else {
        this.dialogVisible = true
        this.imagesPreview = fileArr
      }
    },
    modalClose() {
      this.dialogVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.preview-dialog {
  width: 100%;
  height: 100%;
  overflow: hidden;
  ::v-deep .el-dialog {
    height: 100%;
    width: 100%;
    overflow: hidden;
    background: transparent;
  }
  ::v-deep .el-dialog .el-dialog__body {
    margin-top: -60px;
    border-top: none;
    border-bottom: none;
  }
}
.el-carousel__item {
  text-align: center;
}

.hi-upload-file {
  width: 1200px;
  overflow: hidden;
  display: flex;
  align-content: space-between;
  flex-wrap: wrap;
  .img-list {
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    border: 1px solid #c0ccda;
    .el-image {
      flex: 1;
    }
  }
}
.file-name-class{
  width: 218px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.file-date-class{
  width: 218px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-red{
  color: red;
}
::v-deep .el-carousel__container {
  height: 100%;
}
.el-carousel--horizontal {
  overflow: hidden;
  height: 100%;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
::v-deep .el-carousel__indicators--outside {
  display: none;
}
::v-deep .el-image-viewer__btn {
  position: fixed;
  right: 20px;
  top: 10px;
}
::v-deep .el-image__inner,
.el-image__placeholder,
.el-image__error {
  // height:auto;
  width: 218px;
  height: 218px;
  vertical-align: middle;
  align-items: center;
}
.img-text {
  display: flex;
  span {
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    text-align: center;
    line-height: 28px;
  }
}
.el-image-viewer__close {
  color: #fff;
  .el-icon-error:before {
    color: #fff;
  }
}
.video-div {
  width: 218px;
  height: 218px;
  padding-top: 50px;
  text-align: center;
  font-size: 110px;
}
</style >
